import { Dropdown } from 'react-bootstrap';

interface PageSizeSelectorProps {
  itemsPerPage: string;
  onItemsPerPageChange: (value: string) => void;
}

export function PageSizeSelector({ itemsPerPage, onItemsPerPageChange }: PageSizeSelectorProps) {
  const pageSizeOptions = ['10', '15', '20', '30', '50', '100'];

  return (
    <Dropdown className="w-full">
      <Dropdown.Toggle
        variant="outline-dark"
        className="bg-gray-50 hover:bg-gray-100"
        style={{ width: '80px' }}
      >
        {itemsPerPage}
      </Dropdown.Toggle>
      <Dropdown.Menu className="p-2 max-h-96 overflow-y-auto" style={{ width: '100px' }}>
        {pageSizeOptions.map((size) => (
          <Dropdown.Item key={size} onClick={() => onItemsPerPageChange(size)} active={size === itemsPerPage}>
            {size} per page
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}
